/* eslint-disable max-len */
import { SearchProjects } from './constants';

export const searchProjectsRequest = (data, callback) => ({ type: SearchProjects.searchProjectsRequest, data, callback });
export const searchProjectsSuccess = (data) => ({ type: SearchProjects.searchProjectsSuccess, data });

export const updateSearchProjectRequest = (data, callback) => ({ type: SearchProjects.updateSearchProjectRequest, data, callback });
export const updateSearchProjectSuccess = (data) => ({ type: SearchProjects.updateSearchProjectSuccess, data });
